// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TemplateCreateDocumentPayStub_wrapper__8Qp5M"};